
    import React from "react";
    import {useSelector} from "react-redux";

function News1() {

    const data = useSelector(state => state.load.data);

    return (
        <div className="container">
            <div className="current_img">
                <img className="curr_img_news" src="../images/news/1.jpg" alt=""/>
            </div>
            <div className="current_new">
                <p className="begin_current_news">{data && data.News[0].news1[0]}</p>
                <p className="end_current_news">
                    {data && data.News[0].news1[1]}
                    <br/>
                    <br/>
                    {data && data.News[0].news1[2]}
                    <br/>
                    <br/>
                    {data && data.News[0].news1[3]}
                    <br/>
                    <br/>
                </p>
            </div>
        </div>
    );
}

export default News1;
